import { render, staticRenderFns } from "./LinksGroup.vue?vue&type=template&id=283a6544"
import script from "./LinksGroup.vue?vue&type=script&lang=js"
export * from "./LinksGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports